import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import xml2js from 'xml2js';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import isEmpty from 'lodash.isempty';
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import {setLevelfilter} from '../../actions/layersext';
import {connect} from "react-redux";
import FeatureUtils from "../../utils/FeatureUtils";
import {addLayerFeatures, removeLayer} from 'qwc2/actions/layers';
import * as uuid from 'uuid';
import {changeZoomLevel, panTo, zoomToExtent} from "../../../qwc2/actions/map";
import {LayerRole} from "../../../qwc2/actions/layers";
import CsvUtils from "../../utils/CsvUtils";
import FileUtils from "../../utils/FileUtils";

class AjaxTableTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        addLayerFeatures: PropTypes.func,
        changeZoomLevel: PropTypes.func,
        feature: PropTypes.object,
        panTo: PropTypes.func,
        removeLayer: PropTypes.func,
        setDetailWindow: PropTypes.func,
        setLevelfilter: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string,
        zoomToExtent: PropTypes.func
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            urlDataMap: {},
            multiaction: '',
            isLoading: true,
            selections: []
        };
    }

    sort(data) {
        if (this.props.tab.config.sort && this.props.tab.config.sort.length > 0) {
            const sorts = this.props.tab.config.sort;
            if (data.features && data.features.length > 0) {
                data.features.sort((a, b) => {
                    let result = 0;
                    let counter = 0;
                    while (result == 0) {
                        const sort = sorts[counter];
                        if (sort) {
                            let attribute = 'id';
                            if (sort.attribute) {
                                attribute = sort.attribute;
                            }
                            let direction = 'asc';
                            if (sort.direction) {
                                direction = sort.direction;
                            }
                            const orderFactor = (direction == 'asc') ? 1 : -1;
                            let type = 'string';
                            if (sort.type) {
                                type = sort.type;
                            }

                            let aval = a.properties[attribute];
                            let bval = b.properties[attribute];
                            switch (type) {
                                case 'integer':
                                    aval = this.parseInteger(aval);
                                    bval = this.parseInteger(bval);
                                    result = orderFactor * (aval - bval);
                                    break;
                                default:
                                    aval = this.parseString(aval);
                                    bval = this.parseString(bval);
                                    result = orderFactor * aval.localeCompare(bval);
                                    break;
                            }
                        } else {
                            return result;
                        }
                        counter++;
                    }

                    return result;
                });
            }
        }
        return data;
    }

    parseInteger(val) {
        if (val === null) {
            return 0;
        }
        if (typeof (val) === 'undefined') {
            return 0;
        }
        if (isNaN(val)) {
            return 0;
        }
        return parseInt(val, 10);
    }

    parseString(val) {
        if (val === null) {
            return '';
        }
        if (typeof (val) === 'undefined') {
            return '';
        }
        if (typeof (val) === 'string') {
            return val;
        }
        return '' + val;
    }

    componentDidMount() {
        this.loadDataForTable();
    }

    loadDataForTable() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
        const format = this.props.tab.config.format || 'json';
        if (format == 'xml') {
            this.loadXml(url);
        } else {
            this.loadJson(url);
        }
    }

    loadXml(url) {
        const self = this;
        axios(url).then(response => {
            xml2js.parseString(
                response.data, {
                    tagNameProcessors: [xml2js.processors.stripPrefix],
                    explicitArray: false
                },
                (ignore, parseResult) => {
                    if (parseResult === undefined) {
                        console.log("Parse error *** : " + response.data);
                    } else {
                        const data = self.convertXml(parseResult);
                        self.setState({
                            data: self.sort(data),
                            isLoading: false
                        });
                        self.loadAuthImages(data);
                    }
                }
            );
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }


    loadAuthImages(data) {
        const self = this;

        if (data.features) {
            this.getColumns().map(column => {
                if (column.type && column.type.toLowerCase() == 'image') {
                    data.features.map(item => {
                        const url = FeatureUtils.prepareUrl(item, column.src);
                        if (column.auth && column.auth === true) {
                            self.loadImageWithAuth(url, function (datasrc) {
                                const map = self.state.urlDataMap;
                                map[url] = datasrc;
                                self.setState({
                                    urlDataMap: map
                                });
                            });
                        } else {
                            const map = self.state.urlDataMap;
                            map[url] = url;
                            self.setState({
                                urlDataMap: map
                            });
                        }
                    });
                }
            });
        }
    }

    convertXml(data) {
        const items = [];
        const listPath = this.props.tab.config.xmlListPath || '';
        const propertyPath = this.props.tab.config.xmlPropertyPath || '';

        if (data || listPath != '') {
            listPath.split('.').forEach(pathElement => {
                data = data[pathElement];
            });
        }
        if (data && data.length) {
            data.forEach(datum => {
                if (propertyPath) {
                    propertyPath.split('.').forEach(pathElement => {
                        datum = datum[pathElement];
                    });
                }
                if (!datum.id) {
                    datum.id = uuid.v4();
                }
                items.push({
                    id: datum.id,
                    properties: datum
                });
            });
        }
        return {
            features: items
        };
    }

    loadJson(url) {
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: self.sort(response.data),
                isLoading: false
            });
            self.loadAuthImages(response.data);
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    renderTable() {
        if (!this.state.data || !this.state.data.features) {
            return null;
        }
        if (this.state.data.features.length === 0) {
            return (
                <p>
                    {LocaleUtils.tr("featuredetails.noitems")}
                </p>
            );
        }
        return (<table className="feature-ajax-table">
            {this.renderHead()}
            {this.renderBody()}
        </table>);
    }

    render() {

        return (
            <div className="feature-details-ajax">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderDownloads()}
                        {this.renderTable()}
                        {this.renderMultiactions()}
                    </div>
                }
            </div>
        );
    }

    getColumns() {
        const columns = [];
        if (this.props.tab.config && this.props.tab.config.columns) {
            this.props.tab.config.columns.forEach(c => {
                columns.push(c);
            });
        } else {
            if (this.state.data.features[0]) {
                Object.keys(this.state.data.features[0].properties).forEach(k => {
                    columns.push({
                        key: k,
                        label: k
                    });
                });
            }
        }

        return columns;
    }

    renderDownloads() {
        if (this.props.tab.config.download && this.state.data.features && this.state.data.features.length > 0) {
            return (
                <div className="feature-details-ajax-download">
                    {this.props.tab.config.download.map(item => {
                        return this.renderDownload(item);
                    })}
                </div>
            );
        }
        return null;
    }

    renderMultiactions() {
        if (this.props.tab.config.multiactions && this.state.data.features && this.state.data.features.length > 0) {
            return (
                <div className="feature-details-ajax-multiactions">
                    <select value={this.state.multiaction}
                            onChange={ev => this.setState({multiaction: ev.target.value})}>
                        <option key="-" value="-">-</option>
                        {this.props.tab.config.multiactions.map(item => {
                            return (
                                <option key={item.label} value={item.label}>{item.label}</option>
                            );
                        })}
                    </select>
                    <button className="button"
                            onClick={() => this.executeMultiaction()}>{LocaleUtils.tr("basic.executeaction")}</button>
                </div>
            );
        }
        return null;
    }

    getAction(label) {
        const actions = this.props.tab.config.multiactions;
        for (let i = 0; i < actions.length; i++) {
            if (actions[i].label === label) {
                return actions[i];
            }
        }
        return null;
    }

    executeMultiaction() {
        console.log('Action', this.state.multiaction);
        const action = this.getAction(this.state.multiaction);
        if (action !== null) {
            const selectedValues = this.state.selections.map(item => {
                return FeatureUtils.resolveValue(item, action.select);
            });
            switch (action.type) {
                case 'download':
                    const delimiter = action.delimiter || ',';
                    const selection = selectedValues.join(delimiter);
                    const url = action.url.replaceAll("{selection}", selection);
                    document.location = url;
                    break;
                default:
                    conole.log('Action not implemented', action.type);
                    break;
            }
        }
    }

    renderDownload(download) {
        const label = download.label || download.type;
        return (
            <div key={download.type}>
                <button className="button" onClick={() => this.download(download.type)}
                        title={download.type}>{label}</button>
            </div>
        );
    }

    download(type) {
        // collect data
        const allData = [];
        const head = [];
        this.getColumns().forEach(c => {
            head.push(c.label);
        });
        allData.push(head);
        this.state.data.features.forEach(item => {
            const row = [];

            this.getColumns().forEach(c => {
                row.push(item.properties[c.key] || '');
            });
            allData.push(row);
        });

        const downloadName = (this.props.tab.label || this.props.tab.view);

        if (type === 'csv') {
            const csv = CsvUtils.toCsv(allData);
            const content = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
            return FileUtils.download(downloadName + '.csv', content);
        }

        if (type === 'excelcsv') {
            const csv = CsvUtils.toCsv(allData, {delimiter: ';'}); // typical for DE Excel
            const BOM = "\uFEFF";
            const blob = new Blob([BOM + csv], {type: "text/csv;charset=utf-8"});
            return FileUtils.download(downloadName + '.csv', blob);
        }

        // default json
        const jsonContent = "data:application/json;charset=utf-8," + JSON.stringify(allData);
        return FileUtils.download(downloadName + '.json', jsonContent);
    }

    renderBody() {
        return (
            <tbody>
            {this.state.data.features.map(item => {
                return this.renderRow(item);
            })}
            </tbody>
        );
    }

    renderRow(item) {
        let cssClass = "";
        if (this.props.tab.config.rows) {
            if (this.props.tab.config.rows.mouseover || this.props.tab.config.rows.click) {
                cssClass = "interactive";
            }
        }
        return (
            <tr className={cssClass} key={item.properties.id} onMouseOver={() => this.rowMouseOver(item)}>
                {this.getColumns().map(c => {
                    return this.renderColumn(item, c);
                })}
            </tr>
        );
    }

    renderHead() {
        return (
            <thead>
            <tr>
                {this.getColumns().map(c => {
                    let content = c.label;
                    switch (c.type) {
                        case 'multiselect':
                            content = (
                                <span>
                                <input checked={true} className="ajax-table-check" onChange={() => this.checkAll()}
                                       type="checkbox"/>
                                <input checked={false} className="ajax-table-check" onChange={() => this.checkNone()}
                                       type="checkbox"/>
                                </span>
                            );
                            break;
                    }
                    return (
                        <th key={c.key}>{content}</th>
                    );
                })}
            </tr>
            </thead>
        );
    }

    checkAll() {
        this.checkNone();
        this.state.data.features.forEach(item => this.checkItem(item));
    }

    checkNone() {
        this.setState({selections: []});
    }

    checkItem(key) {
        const sel = this.state.selections;
        const find = sel.indexOf(key);
        if (find > -1) {
            sel.splice(find, 1);
        } else {
            sel.push(key);
        }

        this.setState({
            selections: sel
        });
    }

    isSelected(item) {
        const is = this.state.selections.includes(item);
        return is;
    }

    renderColumn(item, column) {
        let style = {};
        if (column.style) {
            style = column.style;
        }
        let allowClick = true;

        let value = null;
        if (column.value) {
            value = column.value;
            value = FeatureUtils.genericResolve(item, value);
        } else {
            value = item.properties[column.key];
            if (typeof value === 'undefined' || value === null) {
                value = '';
            }
        }
        value = this.attribValue(value, column);

        if (column.type) {
            let content = null;
            switch (column.type.toLowerCase()) {
                case "multiselect":
                    allowClick = false;
                    content = (
                        <input className="ajax-table-check" onChange={() => this.checkItem(item)}
                               checked={this.isSelected(item)} type="checkbox"/>
                    );
                    break;
                case "actions":
                    allowClick = false;
                    content = this.renderActionElements(item, column.elements);
                    break;
                case "image":
                    allowClick = false;
                    const url = FeatureUtils.prepareUrl(item, column.src);
                    const map = this.state.urlDataMap;
                    if (!map[url]) {
                        content = null;
                    } else {
                        const href = FeatureUtils.prepareUrl(item, column.href);
                        content = this.renderImage(map[url], column.width, column.height, href);
                    }
                    break;
                case "linktitle":
                    content = this.renderLinkTitle(item, column.objectType);
                    break;
                case "linkphone":
                    content = this.linkPhone(value);
                    break;
                case "linkemail":
                    content = this.linkEmail(value);
                    break;
                default:
                    content = (
                        <span>
                            Unknown column type {column.type}
                        </span>
                    );
            }
            return (
                <td key={column.key} onClick={() => this.rowClick(item, allowClick)} style={style}>
                    {content}
                </td>
            );
        }
        return (
            <td key={column.key} onClick={() => this.rowClick(item, allowClick)}
                style={style}>{value}</td>
        );
    }

    rowMouseOver(item) {
        if (this.props.tab.config.rows && this.props.tab.config.rows.mouseover) {
            this.executeAction(item, this.props.tab.config.rows.mouseover);
        }
    }

    rowClick(item, allowClick) {
        if (!allowClick) {
            return;
        }
        if (this.props.tab.config.rows && this.props.tab.config.rows.click) {
            this.executeAction(item, this.props.tab.config.rows.click);
        }
    }

    executeAction(item, action) {
        if (action.confirm) {
            if (confirm(action.confirm)) {
                this.finalExecuteAction(item, action);
            }
        } else {
            this.finalExecuteAction(item, action);
        }
    }

    finalExecuteAction(item, action) {
        if (action.type) {
            switch (action.type.toLowerCase()) {
                case 'switchlevel':
                    const attribute = action.attribute || 'level';
                    const level = item.properties[attribute];
                    this.props.setLevelfilter(level);
                    break;
                case 'download':
                    const url = FeatureUtils.prepareUrl(item, action.url);
                    document.location = url;
                    break;
                case 'delete':
                    // The request is authorized by the bearer header. A token in the url (as in older
                    // configurations, appended with & to the path) would become part of the object id.
                    const durl = FeatureUtils.prepareUrl(item, action.url).replace(/[&?]token=[^&]*$/, '');
                    axios.delete(durl).then(() => {
                        this.loadDataForTable();
                    }).catch(error => {
                        // eslint-disable-next-line no-console
                        console.log("Delete failed: " + (error?.response?.data?.detail ?? error?.message ?? error));
                    });
                    break;
                case 'panto':
                    this.panTo(item);
                    break;
                case 'highlight':
                    this.highlight(item);
                    break;
                case 'zoomto':
                    this.zoomTo(item);
                    break;
                case 'linkcomponent':
                    if (action.href) {
                        const href = FeatureUtils.resolveValues(item, action.href);
                        this.openComponentUrl(href);
                    } else {
                        this.openComponent(item);
                    }
                    break;
                case 'linkdetails':
                default:
                    if (action.href) {
                        const href = FeatureUtils.resolveValues(item, action.href);
                        this.goToObjectUrl(href);
                    } else {
                        this.goToItem(item);
                    }
                    break;
            }
        }
    }

    hasAction(item, action) {
        switch (action.type) {
            case 'panTo':
            case 'highlight':
            case 'zoomTo':
                return this.hasGeometry(item);
            default:
                return true;
        }
    }

    renderAction(item, element) {
        const icon = element.icon || 'icon-eye';
        const title = element.title || '';

        if (!this.hasAction(item, element)) {
            return null;
        }

        return (
            <span onClick={() => this.executeAction(item, element)} title={title}>
                <span className={'icon icon_clickable ' + icon}></span>
            </span>
        );
    }

    highlight = (item) => {
        if (this.hasGeometry(item)) {
            // copy, the item may belong to the redux state
            const results = [{...item, crs: 'EPSG:4326'}];
            if (!isEmpty(results)) {
                this.props.removeLayer("identifyslection");
                const layer = {
                    id: "identifyslection",
                    role: LayerRole.SELECTION
                };
                this.props.addLayerFeatures(layer, results, true);
            } else {
                this.props.removeLayer("identifyslection");
            }
        }
    }

    renderActionElements(item, elements) {
        return (
            <span>
                {elements.map(e => {
                    return (
                        <span className="actions" key={e.type}>
                        {this.renderAction(item, e)}
                        </span>
                    );
                })}
            </span>
        );
    }

    goToItem(item) {
        console.log('Go to item', item);
        const id = item.properties.id || item.id;
        const type = item.properties.objectType;
        this.goToObject(id, type);
    }
}

const selector = (state) => ({
    map: state.map
});

export default connect(selector, {
    addLayerFeatures: addLayerFeatures,
    removeLayer: removeLayer,
    changeZoomLevel: changeZoomLevel,
    setLevelfilter: setLevelfilter,
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
    panTo: panTo,
    zoomToExtent: zoomToExtent
})(AjaxTableTab);
